import Ajax from "Utils/ajax";
export const leaveRegister = (data) => Ajax.post('hr/leaveRegister',data); 
export const getAllStaffByHRorManager = (data) => Ajax.post('hr/getAllStaffByHRorManager',data); 